interface ITaxCountries {
    eu: string[];
    nonEU: string[];
    CH: string[];
}

export const taxCountries: ITaxCountries = {
    eu: [
        'es-ES',
        'fr-FR',
        'de-AT',
        'cs-CZ',
        'bg-BG',
        'el-GR',
        'it-IT',
        'lt-LT',
        'lv-LV',
        'mt-MT',
        'sv-SE',
        'nl-BE',
        'nl-NL',
        'pl-PL',
        'pt-PT',
        'ro-RO',
        'sk-SK',
        'sl-SI',
        'en-IE',
        'et-EE',
        'fi-FI',
        'fr-LU',
        'de-LU',
        'hr-HR',
        'hu-HU',
        'el-CY',
    ],
    nonEU: [
        'is-IS',
        'nb-NO',
        'sq-AL',
        'sr-BA',
        'sr-ME',
        'sr-RS',
        'en-GB',
        'he-IL',
        'tr-TR',
        'bs-BA',
        'de-CH',
        'fr-CH',
        'it-CH',
    ],
    CH: ['de-CH', 'fr-CH', 'it-CH'],
};

// Function that extracts ISO country codes from taxCountries (only the country part, not language)
export const taxCountriesIso = (): ITaxCountries => {
    const result: ITaxCountries = {
        eu: [],
        nonEU: [],
        CH: [],
    };

    // Process each category (eu, nonEU, CH)
    (Object.keys(taxCountries) as Array<keyof ITaxCountries>).forEach((category) => {
        // For each country code in the category, extract the ISO part (after the hyphen)
        result[category] = taxCountries[category]
            .map((countryCode) => {
                const parts = countryCode.split('-');
                return parts.length > 1 ? parts[1] : countryCode;
            })
            .filter((code): code is string => code !== undefined);

        // Remove duplicates (using Array.from instead of spread for better compatibility)
        result[category] = Array.from(new Set(result[category]));
    });

    return result;
};
